import React from "react";
import PropTypes from "prop-types";
import Iconify from "../iconify/Iconify";
import "./ButtonsNew.scss";

const ButtonContent = ({ isLoading, textWithIcon, iconClass, buttonText, isIcon }) => (
    <>
        {isLoading ? (
            <>
                <div className="button-loading-part"></div>   <span className={textWithIcon ? "label-l-space" : ""}>{buttonText}</span>
            </>
        ) : (
            <>
                {textWithIcon && <Iconify icon={iconClass} className="button-icon" />}
                {buttonText && (
                    <span className={textWithIcon ? "label-l-space" : ""}>{buttonText}</span>
                )}
                {isIcon && <Iconify icon={iconClass} className="button-icon" />}
            </>
        )}
    </>
);

const TooltipButton = ({ titleText, onClick, buttonTypeClassName, isDisable, isLoading, textWithIcon, iconClass, buttonText, isIcon, tootipText }) => (
    <span className="tooltip-div btn-tooltip">
        <button
            type="button"
            className={`btn ${buttonTypeClassName} ${isDisable ? "disable-btn" : ""}`}
            onClick={onClick}
            disabled={isDisable}
            title={titleText}
        >
            <ButtonContent
                isLoading={isLoading}
                textWithIcon={textWithIcon}
                iconClass={iconClass}
                buttonText={buttonText}
                isIcon={isIcon}
            />
        </button>
        <div className="tooltip-show">
            <p>{tootipText}</p>
        </div>
        <div className="tooltip-arrow-icon"></div>
    </span>
);

const RegularButton = ({ titleText, onClick, buttonTypeClassName, isDisable, isLoading, textWithIcon, iconClass, buttonText, isIcon }) => (
    <button
        type="button"
        className={`btn ${buttonTypeClassName} ${isDisable ? "disable-btn" : ""}`}
        onClick={onClick}
        disabled={isDisable}
        title={titleText}
    >
        <ButtonContent
            isLoading={isLoading}
            textWithIcon={textWithIcon}
            iconClass={iconClass}
            buttonText={buttonText}
            isIcon={isIcon}
        />
    </button>
);

const ButtonsNew = (props) => {
    const {
        titleText,
        isLoading,
        buttonTypeClassName,
        onClick,
        textWithIcon,
        isIcon,
        iconClass,
        buttonText,
        isDisable,
        isTooltip,
        tootipText,
    } = props;

    return isTooltip ? (
        <TooltipButton
            titleText={titleText}
            onClick={onClick}
            buttonTypeClassName={buttonTypeClassName}
            isDisable={isDisable}
            isLoading={isLoading}
            textWithIcon={textWithIcon}
            iconClass={iconClass}
            buttonText={buttonText}
            isIcon={isIcon}
            tootipText={tootipText}
        />
    ) : (
        <RegularButton
            titleText={titleText}
            onClick={onClick}
            buttonTypeClassName={buttonTypeClassName}
            isDisable={isDisable}
            isLoading={isLoading}
            textWithIcon={textWithIcon}
            iconClass={iconClass}
            buttonText={buttonText}
            isIcon={isIcon}
        />
    );
};

export default ButtonsNew;

/** PropTypes for ButtonContent */
ButtonContent.propTypes = {
    isLoading: PropTypes.bool,
    textWithIcon: PropTypes.bool,
    iconClass: PropTypes.string,
    buttonText: PropTypes.string,
    isIcon: PropTypes.bool,
};

/** PropTypes for TooltipButton */
TooltipButton.propTypes = {
    titleText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    buttonTypeClassName: PropTypes.string,
    isDisable: PropTypes.bool,
    isLoading: PropTypes.bool,
    textWithIcon: PropTypes.bool,
    iconClass: PropTypes.string,
    buttonText: PropTypes.string,
    isIcon: PropTypes.bool,
    tootipText: PropTypes.string.isRequired,
};

/** PropTypes for RegularButton */
RegularButton.propTypes = {
    titleText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    buttonTypeClassName: PropTypes.string,
    isDisable: PropTypes.bool,
    isLoading: PropTypes.bool,
    textWithIcon: PropTypes.bool,
    iconClass: PropTypes.string,
    buttonText: PropTypes.string,
    isIcon: PropTypes.bool,
};

/** PropTypes for ButtonsNew */
ButtonsNew.propTypes = {
    titleText: PropTypes.string,
    isLoading: PropTypes.bool,
    buttonTypeClassName: PropTypes.string,
    onClick: PropTypes.func,
    textWithIcon: PropTypes.bool,
    buttonText: PropTypes.string,
    isIcon: PropTypes.bool,
    iconClass: PropTypes.string,
    isDisable: PropTypes.bool,
    isTooltip: PropTypes.bool,
    tootipText: PropTypes.string,
};